import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import styles from './maker-board-write-progress-modal.css';

const STEP_LABELS = [
    {key: 'compiling', label: 'コンパイル中…'},
    {key: 'writing', label: '書き込み中…'},
    {key: 'done', label: '完了'}
];

const STEP_INDEX = {compiling: 0, writing: 1, done: 2};

class MakerBoardWriteProgressModal extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            visible: false,
            stage: null,
            errorMessage: ''
        };
        this.handleProgress = this.handleProgress.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    componentDidMount () {
        const runtime = this.getRuntime();
        if (runtime) {
            runtime.on('MAKERBOARD_WRITE_PROGRESS', this.handleProgress);
        }
    }

    componentWillUnmount () {
        const runtime = this.getRuntime();
        if (runtime) {
            runtime.removeListener('MAKERBOARD_WRITE_PROGRESS', this.handleProgress);
        }
    }

    getRuntime () {
        const vm = this.props.vm;
        return (vm && vm.runtime) || null;
    }

    handleProgress (payload) {
        const stage = payload && payload.stage;
        if (stage === 'error') {
            this.setState({
                visible: true,
                stage: 'error',
                errorMessage: (payload && payload.message) || 'エラーが発生しました'
            });
        } else if (stage === 'compiling' || stage === 'writing' || stage === 'done') {
            this.setState({
                visible: true,
                stage,
                errorMessage: ''
            });
        }
    }

    handleClose () {
        this.setState({visible: false, stage: null, errorMessage: ''});
    }

    render () {
        const {visible, stage, errorMessage} = this.state;
        if (!visible) return null;

        const isError = stage === 'error';
        const isDone = stage === 'done';
        const canClose = isError || isDone;
        const stepIdx = STEP_INDEX[stage];
        const currentIdx = isError ? -1 : (typeof stepIdx === 'number' ? stepIdx : 0);

        return (
            <div className={styles.overlay}>
                <div className={styles.modal}>
                    <div className={styles.header}>
                        {isError ? '書き込みエラー' : 'プログラムの書き込み'}
                    </div>
                    <div className={styles.body}>
                        {isError ? (
                            <div className={styles.errorMessage}>{errorMessage}</div>
                        ) : (
                            <div className={styles.steps}>
                                {STEP_LABELS.map((step, idx) => {
                                    const completed = idx < currentIdx || (idx === currentIdx && isDone);
                                    const active = idx === currentIdx && !isDone;
                                    return (
                                        <div
                                            key={step.key}
                                            className={classNames(styles.step, {
                                                [styles.stepCompleted]: completed,
                                                [styles.stepActive]: active
                                            })}
                                        >
                                            <span className={styles.stepIcon}>
                                                {completed ? '✓' : (active ? <span className={styles.spinner} /> : '○')}
                                            </span>
                                            <span className={styles.stepLabel}>{step.label}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                    {canClose && (
                        <div className={styles.footer}>
                            <button
                                className={styles.closeButton}
                                onClick={this.handleClose}
                                type="button"
                            >
                                {'閉じる'}
                            </button>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

MakerBoardWriteProgressModal.propTypes = {
    vm: PropTypes.shape({
        runtime: PropTypes.shape({
            removeListener: PropTypes.func
        })
    })
};

export default MakerBoardWriteProgressModal;
